import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { CircularProgress } from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/EditNote";
import Divider from "@mui/material/Divider";
import { setResolutionsList } from "../../redux/slices/resolutionSlice";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "450px",
  width: "95%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  paddingTop: 2,
  paddingBottom: 2,
  paddingLeft: 3,
  paddingRight: 3,
  borderRadius: "10px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "35ch",
      borderRadius: "15%",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: "2%",
    overflow: "hidden",
  },
  button: {
    textTransform: "lowercase",
  },
  heading: {
    fontFamily: "Goudy Bookletter 1911, sans-serif",
    fontSize: "16px",
    marginBottom: "10px",
  },
  label: {
    fontWeight: "bold",
  },
  formContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginTop: "5%",
  },
  fieldContainer: {
    display: "flex",
    alignItems: "center",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
  },
  divider: {
    margin: "20px 0",
  },
}));

export default function MyResolutionForm({ selectedOption }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setEditMode(false);
    setShowAdvanced(false);
    setNewKey("");
    setNewValue("");
    setFormData({
      name: "",
      value: "",

      customProperties: {},
    });
  };
  const headers = useSelector((state) => state.header);
  const classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccessMessage] = useState();
  const api = localStorage.getItem("api");
  const curremms = useSelector((state) => state.curremms);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const dispatch = useDispatch();

  const oldResolutionData = useSelector(
    (state) => state?.resolution?.resolutions
  );
  const [formData, setFormData] = useState({
    name: "",
    value: "",

    customProperties: {},
  });
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");

  const toggleAdvanced = () => {
    setShowAdvanced((prev) => {
      const newShowAdvanced = !prev;
      if (!newShowAdvanced) {
        setEditMode(false);
      }
      return newShowAdvanced;
    });
  };

  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };
  const handleCustomPropertyChange = (event) => {
    const { name, value } = event.target;
   
    setFormData((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        [name]: value,
      },
    }));
  };
  const handleAddCustomProperty = () => {
    if (newKey && newValue) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          [newKey]: newValue,
        },
      }));
      setNewKey("");
      setNewValue("");
    }
  };

  function convertStringToJson(inputString) {
    if (inputString !== null) {
      const properties = inputString?.split(",");
      const result = {};

      for (let property of properties) {
        const [key, value] = property?.split(":");
        result[key.trim()] = value?.trim();
      }

      return result;
    }
  }

  const emmsheaders = useSelector((state) => state.emmsheader);

  const handleSubmit = (event) => {
    event.preventDefault();

    const { name, value } = formData;
    if (!name?.trim()) {
      toast.error("Name is required.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    if (!value?.trim()) {
      toast.error("Resolution value is required.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }
    setIsSubmitting(true);
    const json2 = { ...formData };

    const requestBody = {
      path: "resolution",
      query: {},
      emmsId: `${selectedOption}`,
      body: { ...json2 },
      requestType: "POST",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        setIsSubmitting(false);
        setErrorModalOpen(true);
        const combinedData = [response?.data, ...oldResolutionData];
        dispatch(setResolutionsList(combinedData));
        setErrorMessage(`Resolution created successfully`);
        setFormData({
          name: "",
          value: "",

          customProperties: {},
        });
        setSuccessMessage(true);
      })
      .catch((error) => {
        setErrorModalOpen(true);
        setFormData({
          name: "",
          value: "",

          customProperties: {},
        });
        setErrorMessage(`Error creating resolution: ${error?.response?.data}`);
        setSuccessMessage(false);
      });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");
    setOpen(false);
    setIsSubmitting(false);
  };
  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <div>
      <Button
        style={{ textTransform: "none" }}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Add Resolution
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div>
              <h2>Resolutions</h2>
              <h4 style={{ fontWeight: "100" }}>
                Add resolution for {curremms?.curremms?.name}{" "}
              </h4>
            </div>

            {!showAdvanced && (
              <div className={classes.formContainer}>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Alias:", true)}
                  <TextField
                    required
                    id="name"
                    label="4K, Mobile"
                    name="name"
                    margin="none"
                    size="small"
                    variant="outlined"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Value:", true)}
                  <TextField
                    required
                    id="value"
                    label="eg. 1920x1080"
                    name="value"
                    margin="none"
                    size="small"
                    variant="outlined"
                    value={formData.value}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}

            <div className={classes.buttonContainer}>
              <Button
                style={{
                  textTransform: "none",
                }}
                variant="outlined"
                color="primary"
                onClick={toggleAdvanced}
                startIcon={showAdvanced ? <ArrowBackIcon /> : null}
              >
                {showAdvanced ? "Back" : "Advanced"}
              </Button>
              {showAdvanced && (
                <Button
                  style={{
                    textTransform: "none",
                  }}
                  variant="contained"
                  color="primary"
                  onClick={toggleEditMode}
                  endIcon={!editMode ? <EditIcon /> : null}
                >
                  {editMode ? "Save Changes" : "Edit JSON"}
                </Button>
              )}
              {!showAdvanced && (
                <Box 
                sx={{
                  display:"flex",
                  gap:2
                }}
                >
                  <Button
                    style={{ textTransform: "none" }}
                    variant="outlined"
                    color="error"
                    onClick={() => setOpen(false)}
                    disabled={isSubmitting}
                  >
                    Close
                  </Button>

                  <Button
                    style={{
                      textTransform: "none",
                    }}
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? <CircularProgress size={24} /> : "Submit"}
                  </Button>
                </Box>

              )}
            </div>
            {showAdvanced && editMode && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Edit Custom Properties</h6>
                <div>
                  {Object.keys(formData.customProperties).map((key) => (
                    <div key={key} style={{ margin: "15px 0" }}>
                      <TextField
                        id={key}
                        name={key}
                        label={key}
                        variant="outlined"
                        size="small"
                        value={formData.customProperties[key]}
                        onChange={handleCustomPropertyChange}
                      />
                    </div>
                  ))}
                </div>
                {Object.keys(formData.customProperties).length > 0 && (
                  <div className={classes.divider}>
                    <Divider />
                  </div>
                )}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    id="newKey"
                    name="newKey"
                    label="New Key"
                    variant="outlined"
                    size="small"
                    value={newKey}
                    onChange={(e) => setNewKey(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <TextField
                    id="newValue"
                    name="newValue"
                    label="New Value"
                    variant="outlined"
                    size="small"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={handleAddCustomProperty}
                  >
                    Add
                  </Button>
                </div>
              </div>
            )}
            <div className={classes.jsoncontainer}>
              {showAdvanced && (
                <div
                  style={{
                    maxWidth: "500px",
                    marginTop: "10px",
                    padding: "10px",
                    border: "1px solid #ccc",
                  }}
                >
                  <h6>Custom Properties</h6>
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                    }}
                  >
                    {JSON.stringify(formData.customProperties, null, 2)}
                  </pre>
                </div>
              )}
            </div>

            <Modal
              open={errorModalOpen}
              onClose={handleModalClose}
              className={classes.modal}
            >
              <div className={classes.paper}>
                {success ? <h2>Congratulations</h2> : <h2>Error</h2>}
                <p>{errorMessage}</p>
                <Button
                  style={{
                    textTransform: "none",

                    marginLeft: "75%",
                  }}
                  onClick={handleModalClose}
                  variant="contained"
                  color="primary"
                >
                  Close
                </Button>
              </div>
            </Modal>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
